import React from 'react'
import { useTranslation } from 'react-i18next'

interface InjectedTranslationComponentProps {
  expression: string
}

const TranslationElement: React.FC<InjectedTranslationComponentProps> = (props) => {
  const { t } = useTranslation()
  let expression = props.expression

  if (props.expression.indexOf('t(') >= 0) {
    expression = t(`common:${props.expression.replace('t(', '').replace(')', '')}`)
  }

  return (
    <>{t(expression)}</>
  )
}
export default TranslationElement
